import React, { memo } from "react";
import { Box, FormControlLabel, Grid, TextField } from "@mui/material";
import { FormikProps, getIn, useFormikContext } from "formik";
import { includes } from "ramda";
import { CardType, Data } from "../../../store/processor/types";
import CustomizedCheckbox from "../../../common/formElements/Checkbox";
import TextInput from "../../../common/formElements/TextInput";
import { isNil } from "lodash";
import AutocompleteField from "../../../common/formElements/AutocompleteField";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface ProcessorBinForm {
  index: number;
  cardtype: CardType;
}

const ProcessorBinForm = (props: ProcessorBinForm) => {
  const { index, cardtype } = props;
  const formikProps = useFormikContext();
  const { values, setFieldValue } = formikProps as FormikProps<Data>;
  const accounts = ["Cheque", "Savings", "Credit", "Default"];
  const listCardType: any = useSelector(
    (state: ApplicationState) => state.cardType.data?.data
  ) ?? [{}];

  return (
    <Grid container alignItems="flex-start" spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.CardType[${index}].AmountFrom`}
          label="Amount From"
          type="number"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.CardType[${index}].AmountTo`}
          label="Amount To"
          type="number"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <AutocompleteField
          key={"branches-" + listCardType.length}
          fieldname={`attributes.CardType[${index}].ProductID`}
          options={listCardType.filter(i => i.ProductID)}
          value={listCardType.find((c) => c.ProductID === values.attributes.CardType[index].ProductID)}
          onChange={(e, value) => {
            if (!isNil(value)) {
              setFieldValue(`attributes.CardType[${index}].ProductID`, !isNil(value) ? value.ProductID : "")
              setFieldValue(`attributes.CardType[${index}].ProductName`, !isNil(value) ? value.type : "")
            }
          }}
          getOptionLabel={(option): string =>
            `${option.ProductID} - ${option.type}`
          }
          renderOption={(props, option) => (
            <div
              {...props}
            >{`${option.ProductID} - ${option.type}`}</div>
          )}
          renderInput={(params) => (
            <TextField {...params} label="ProductID" variant="outlined" />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default memo(ProcessorBinForm);
